export default __webpack_public_path__ + "static/media/image-transfer.899f2e5b.jpg";